import {
  APPLICATION_REVIEW_LOADING_STATUS_UPDATE,
  ENROLLMENT_LOADING_STATUS_UPDATE,
  LISTING_APPLICATIONS_TAB_LOADING_STATUS_UPDATE,
} from '../constants/actionTypes';

const initState = () => ({
  listingApplicationsTabStatus: {
    isError: false,
    show: true,
    showSpinner: true,
  },
  applicationReviewStatus: {
    isError: false,
    show: true,
    showSpinner: true,
  },
  enrollmentLoadingStatus: {
    showSpinner: false,
  },
});

function loadingScreenStatus(state = initState(), action = {}) {
  const { type, payload } = action;

  let newState;
  switch (type) {
    case LISTING_APPLICATIONS_TAB_LOADING_STATUS_UPDATE:
      return { ...state, listingApplicationsTabStatus: { ...payload } };
    case APPLICATION_REVIEW_LOADING_STATUS_UPDATE:
      return { ...state, applicationReviewStatus: { ...payload } };
    case ENROLLMENT_LOADING_STATUS_UPDATE:
      return { ...state, enrollmentLoadingStatus: { ...payload } };
    default:
      newState = state;
      break;
  }

  return newState;
}

export default loadingScreenStatus;
